import { cellRenderParseData } from '../../utils/functions';

const columnDataGrid = [
  {
    dataField: 'signerId',
    caption: 'Id',
    notVisible: false,
    dataType: 'number',
    width: 60
  },
  {
    dataField: 'signerName',
    caption: 'ФИО',
    notVisible: false,
    dataType: 'text',
    width: 300
  },
  {
    dataField: 'plantSignerId',
    caption: 'plantSignerId',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'startDate',
    caption: 'Дата начала',
    notVisible: false,
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'finishDate',
    caption: 'Дата завершения',
    notVisible: false,
    cellRender: cellRenderParseData,
    dataType: 'date'
  }
];

export default columnDataGrid;
